import { RouteConfig } from "vue-router"

import { isAuthenticated } from "@/routers/router-guardians"

const routes: Array<RouteConfig> = [
  {
    path: "/encounters/:encounterId/e-prescribe?ePrescribingLink=:ePrescribingLink",
    name: "e-prescribe",
    props: true,
    component: () => import(/* webpackChunkName: "e-prescribe" */ "@/modules/medication/pages/EPrescribe.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    path: "/authorize-ayva",
    name: "authorize-ayva",
    component: () => import(/* webpackChunkName: "e-prescribe" */ "@/modules/medication/pages/AuthorizeAyva.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default routes
